import { S21CsaMycsaAchComponent } from "./S21CsaMycsaAchComponent";

export function S21CsaMycsaAchScreen() {
  return (
    <>
      <S21CsaMycsaAchComponent />
    </>
  );
}
